import React, { useState, useEffect } from 'react';
import { FiFileText, FiAlertCircle } from 'react-icons/fi';
import { useDispatch, useSelector } from 'react-redux';
import { applyEmergencyLeave, resetLeaveFormState } from '../../Redux/Slice/LeaveForm';
import Cookies from 'js-cookie';
import { findJuniorDevelopers } from '../../Redux/Slice/TaskMasterSlice';
import ConfirmModal from '../../Components/ConfirmModal/ConfirmModal';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Loader from '../../Components/Loader/Loader';

const EmergencyLeave = ({ onBack }) => {
    const loginDataStr = Cookies.get("loginData");
    const parsedData = loginDataStr ? JSON.parse(loginDataStr) : null;
    const applicantUser = parsedData?.data || parsedData?.user || {};
    const loggedInUserId = applicantUser?._id;
    const today = new Date().toISOString().split('T')[0];

    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [emergencyType, setEmergencyType] = useState('Medical');
    const [contactContact, setContactContact] = useState('');
    const [location, setLocation] = useState('');
    const [reason, setReason] = useState('');
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [pendingPayload, setPendingPayload] = useState(null);

    const [fromDateError, setFromDateError] = useState(false);
    const [toDateError, setToDateError] = useState(false);
    const [contactError, setContactError] = useState(false);
    const [reasonError, setReasonError] = useState(false);

    const emergencyTypes = ['Medical', 'Family', 'Personal', 'Other'];

    const dispatch = useDispatch();
    const { loading, success, error } = useSelector((state) => state.LeaveForm);
    const { JuniorDevelopers } = useSelector((state) => state.TaskMaster);

    useEffect(() => {
        dispatch(findJuniorDevelopers());
    }, [dispatch]);

    if (loading) {
        return <Loader />;
    }


    const juniorOptions =
        JuniorDevelopers?.data
            ?.filter((junior) => junior?._id !== loggedInUserId)
            ?.map((junior) => ({
                label: junior?.Name,
                Role: junior?.Role,
                _id: junior?._id,
            })) || [];

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!fromDate) {
            setFromDateError(true);
            return;
        }
        if (!toDate || toDate < fromDate) {
            setToDateError(true);
            return;
        }
        if (!contactContact || contactContact.length !== 10) {
            setContactError(true);
            return;
        }
        if (!reason.trim()) {
            setReasonError(true);
            return;
        }

        try {
            let firstApprover = {
                position: "Senior Developer",
                name: "Pending Assignment",
                status: "Pending"
            };

            let secondApprover = {
                name: "DIPAK RAJPUT",
                position: "Delphi Senior Developer",
                approverId: "66f7aac08bd6fc731ee1d02f",
                status: "Pending"
            };

            if (applicantUser.Role === "Delphi Junior Developer" || applicantUser.Role === "Delphi Senior Developer") {
                const targetApprover = juniorOptions.find(opt =>
                    opt.Role === "Delphi Senior Developer" &&
                    opt.label && opt.label.toUpperCase().includes("KALPESH")
                ) || juniorOptions.find(opt => opt.Role === "Delphi Senior Developer");

                firstApprover = {
                    position: "Delphi Senior Developer",
                    name: targetApprover ? targetApprover.label : "KALPESH DILKHUSH",
                    approverId: targetApprover ? targetApprover._id : "682c63fe6b35012c7f3a7dd7",
                    status: "Pending"
                };
            } else if (applicantUser.Role === "Web Junior Developer" || applicantUser.Role === "Web Senior Developer") {
                const targetApprover = juniorOptions.find(opt =>
                    opt.Role === "Web Senior Developer" &&
                    opt.label && opt.label.toUpperCase().includes("JAY")
                ) || juniorOptions.find(opt => opt.Role === "Web Senior Developer");

                firstApprover = {
                    position: "Web Senior Developer",
                    name: targetApprover ? targetApprover.label : "JAY PARMAR",
                    approverId: targetApprover ? targetApprover._id : "676bcd353d488c3eeca8291d",
                    status: "Pending"
                };
            } else if (applicantUser.Role === "Junior Customer Support") {
                const targetApprover = juniorOptions.find(opt =>
                    opt.Role === "Senior Customer Support" &&
                    opt.label && opt.label.toUpperCase().includes("VIPUL")
                ) || juniorOptions.find(opt => opt.Role === "Senior Customer Support");

                firstApprover = {
                    position: "Senior Customer Support",
                    name: targetApprover ? targetApprover.label : "VIPUL KANTHARIA",
                    approverId: targetApprover ? targetApprover._id : "672b4e1df07347a35c340dfa",
                    status: "Pending"
                };
            } else if (applicantUser.Role === "Data Analyst" || applicantUser.Role === "inhouse") {
                // Data Analyst or inhouse: skip firstApprover, go directly to DIPAK RAJPUT → owner
                const approvers = [
                    {
                        name: "DIPAK RAJPUT",
                        position: "Delphi Senior Developer",
                        approverId: "66f7aac08bd6fc731ee1d02f",
                        status: "Pending"
                    },
                    {
                        position: "owner",
                        name: "GOPESH PERIWAL" || "LALIT PERIWAL",
                        status: "Pending"
                    },
                ];

                const payload = {
                    applicantId: applicantUser._id,
                    applicantName: applicantUser.Name,
                    applicantRole: applicantUser.Role,
                    fromDate,
                    toDate,
                    leaveReason: emergencyType,
                    outOfStation: !!location,
                    cityName: location,
                    reason: `${reason}\n\nReachable at: ${contactContact}`,
                    approvers,
                };

                setPendingPayload(payload);
                setShowConfirmModal(true);
                return; // exit early, skip the default approvers block below
            }

            const approvers = [
                firstApprover,
                secondApprover,
                {
                    position: "owner",
                    name: "GOPESH PERIWAL" || "LALIT PERIWAL",
                    status: "Pending"
                },
            ];

            const payload = {
                applicantId: applicantUser._id,
                applicantName: applicantUser.Name,
                applicantRole: applicantUser.Role,
                fromDate,
                toDate,
                leaveReason: emergencyType,
                outOfStation: !!location,
                cityName: location,
                reason: `${reason}\n\nReachable at: ${contactContact}`,
                approvers,
            };

            // Store payload and open confirm modal
            setPendingPayload(payload);
            setShowConfirmModal(true);

        } catch (error) {
            console.error("Error applying emergency leave:", error);
            toast.error("Error applying emergency leave. Please try again.", { position: "top-right", autoClose: 3000 });
        }
    };

    const confirmSubmit = async () => {
        if (!pendingPayload) return;
        setShowConfirmModal(false);
        try {
            const result = await dispatch(applyEmergencyLeave(pendingPayload)).unwrap();
            if (result.status === "Success" || result.success) {
                toast.success("Emergency Leave applied successfully!", { position: "top-right", autoClose: 3000 });
                onBack();
            }
        } catch (err) {
            toast.error(err || "Failed to apply emergency leave.", { position: "top-right", autoClose: 3000 });
        } finally {
            setPendingPayload(null);
        }
    };

    return (
        <>
            <ConfirmModal
                isOpen={showConfirmModal}
                onClose={() => { setShowConfirmModal(false); setPendingPayload(null); }}
                onConfirm={confirmSubmit}
                title="Submit Emergency Leave"
                message="Are you sure you want to submit this Emergency Leave request? It will be sent for immediate approval."
            />
            <div className="w-full bg-white rounded-3xl shadow-[0_20px_50px_rgba(0,0,0,0.05)] border border-gray-100 p-4 md:p-5 relative overflow-hidden">
                <div className="absolute top-0 right-0 w-32 h-32 bg-red-50/50 rounded-full -mr-16 -mt-16 -z-0"></div>
                
                <div className="flex flex-col sm:flex-row justify-between items-start mb-10 gap-4 relative z-10">
                    <div className="flex items-center gap-4">
                        <div className="w-12 h-12 rounded-2xl bg-[#133A69] text-white flex items-center justify-center shadow-lg shadow-blue-900/20 px-4 group">
                            <FiFileText className="w-6 h-6 group-hover:scale-110 transition-transform text-red-400" />
                        </div>
                        <div>
                            <h2 className="text-[20px] font-black text-gray-800 tracking-tight">Emergency Leave</h2>
                            <p className="text-[13px] text-gray-500 mt-0.5 font-medium">Immediate time off request</p>
                        </div>
                    </div>
                    <button
                        onClick={onBack}
                        type="button"
                        className="text-[12px] font-bold text-[#133A69] hover:bg-blue-50 border-2 border-[#133A69]/10 px-4 py-2 rounded-xl transition-all active:scale-95"
                    >
                        Change Type
                    </button>
                </div>

                <div className="bg-red-50 border-2 border-red-100 rounded-2xl p-6 mb-10 flex items-start gap-4 animate-in slide-in-from-top-4 duration-500 relative overflow-hidden">
                    <div className="absolute top-0 right-0 w-16 h-16 bg-red-100/30 rounded-bl-full"></div>
                    <div className="w-10 h-10 rounded-xl bg-red-600 text-white flex items-center justify-center shrink-0 shadow-lg shadow-red-900/20">
                        <FiAlertCircle className="w-6 h-6 animate-pulse" />
                    </div>
                    <div className="relative z-10">
                        <h3 className="text-[14px] font-black text-red-900 uppercase tracking-widest mb-1">Priority Selection</h3>
                        <p className="text-[12px] text-red-700 font-bold leading-relaxed">
                            Emergency requests are flagged for immediate manager attention. Only use for urgent, unforeseen circumstances.
                        </p>
                    </div>
                </div>

                <form onSubmit={handleSubmit} className="space-y-8 relative z-10">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                        <div className="space-y-2">
                            <label className="block text-[13px] font-bold text-gray-700 ml-1">From Date</label>
                            <input
                                type="date"
                                value={fromDate}
                                min={today}
                                onChange={(e) => {
                                    setFromDate(e.target.value);
                                    setFromDateError(false);
                                }}
                                className={`w-full bg-[#f8fafc] border-2 ${fromDateError ? 'border-red-400 ring-4 ring-red-50' : 'border-gray-100 focus:border-[#133A69] focus:ring-4 focus:ring-blue-50'} rounded-2xl px-5 py-4 text-sm outline-none text-gray-700 transition-all font-semibold shadow-sm`}
                            />
                            {fromDateError && (
                                <p className="text-[11px] text-red-500 font-bold mt-2 ml-1 flex items-center gap-1.5 animate-in slide-in-from-left-2">
                                    <FiAlertCircle className="w-3.5 h-3.5" />
                                    Please select a valid from date.
                                </p>
                            )}
                        </div>
                        <div className="space-y-2">
                            <label className="block text-[13px] font-bold text-gray-700 ml-1">To Date</label>
                            <input
                                type="date"
                                value={toDate}
                                min={today}
                                onChange={(e) => {
                                    setToDate(e.target.value);
                                    setToDateError(false);
                                }}
                                className={`w-full bg-[#f8fafc] border-2 ${toDateError ? 'border-red-400 ring-4 ring-red-50' : 'border-gray-100 focus:border-[#133A69] focus:ring-4 focus:ring-blue-50'} rounded-2xl px-5 py-4 text-sm outline-none text-gray-700 transition-all font-semibold shadow-sm`}
                            />
                            {toDateError && (
                                <p className="text-[11px] text-red-500 font-bold mt-2 ml-1 flex items-center gap-1.5">
                                    <FiAlertCircle className="w-3.5 h-3.5" />
                                    Invalid to date selected.
                                </p>
                            )}
                        </div>
                    </div>

                    <div className="space-y-4">
                        <label className="block text-[13px] font-bold text-gray-700 ml-1 uppercase tracking-wider">Emergency Nature</label>
                        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                            {emergencyTypes.map((type) => (
                                <label
                                    key={type}
                                    className={`flex flex-col items-center justify-center p-3 rounded-xl cursor-pointer transition-all border-2 relative overflow-hidden group ${emergencyType === type
                                        ? 'bg-[#133A69] border-[#133A69] shadow-lg text-white'
                                        : 'bg-white border-gray-100 hover:border-gray-200 text-gray-600'
                                        }`}
                                >
                                    <input
                                        type="radio"
                                        name="emergencyType"
                                        value={type}
                                        checked={emergencyType === type}
                                        onChange={(e) => setEmergencyType(e.target.value)}
                                        className="hidden"
                                    />
                                    <span className={`text-[12px] font-bold uppercase tracking-tight ${emergencyType === type ? 'text-white' : 'text-gray-800'}`}>{type}</span>
                                    {emergencyType === type && (
                                        <div className="mt-1 w-1 h-1 rounded-full bg-red-400 animate-pulse"></div>
                                    )}
                                </label>
                            ))}
                        </div>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                        <div className="space-y-2">
                            <label className="block text-[13px] font-bold text-gray-700 ml-1">Contact Number</label>
                            <input
                                type="text"
                                value={contactContact}
                                onChange={(e) => {
                                    const val = e.target.value.replace(/\D/g, '');
                                    if (val.length <= 10) setContactContact(val);
                                    if (val.length === 10) setContactError(false);
                                }}
                                placeholder="10-digit mobile number"
                                className={`w-full bg-[#f8fafc] border-2 ${contactError ? 'border-red-400 ring-4 ring-red-50' : 'border-gray-100 focus:border-[#133A69] focus:ring-4 focus:ring-blue-50'} rounded-2xl px-5 py-4 text-sm outline-none text-gray-700 transition-all font-semibold shadow-sm`}
                            />
                            {contactError && (
                                <p className="text-[11px] text-red-500 font-bold mt-2 ml-1 flex items-center gap-1.5">
                                    <FiAlertCircle className="w-3.5 h-3.5" />
                                    Valid 10-digit number required.
                                </p>
                            )}
                        </div>

                        <div className="space-y-2">
                            <label className="block text-[13px] font-bold text-gray-700 ml-1 text-red-400">Current Location (Optional)</label>
                            <input
                                type="text"
                                value={location}
                                onChange={(e) => setLocation(e.target.value)}
                                placeholder="Where can you be reached?"
                                className="w-full bg-[#f8fafc] border-2 border-gray-100 focus:border-[#133A69] focus:ring-4 focus:ring-blue-50 rounded-2xl px-5 py-4 text-sm outline-none text-gray-700 transition-all font-semibold shadow-sm"
                            />
                        </div>
                    </div>

                    <div className="space-y-2">
                        <label className="block text-[13px] font-bold text-gray-700 ml-1">Emergency Description</label>
                        <textarea
                            value={reason}
                            onChange={(e) => {
                                setReason(e.target.value);
                                if (e.target.value.trim().length > 0) setReasonError(false);
                            }}
                            placeholder="Brief description of the emergency..."
                            className={`w-full bg-[#f8fafc] border-2 ${reasonError ? 'border-red-400 ring-4 ring-red-50' : 'border-gray-100 focus:border-[#133A69] focus:ring-4 focus:ring-blue-50'} rounded-2xl px-5 py-4 text-sm outline-none text-gray-700 transition-all font-semibold shadow-sm min-h-[120px] resize-y`}
                        ></textarea>
                        {reasonError && (
                            <p className="text-[11px] text-red-500 font-bold mt-2 ml-1 flex items-center gap-1.5">
                                <FiAlertCircle className="w-3.5 h-3.5" />
                                Details are required for emergency filing.
                            </p>
                        )}
                    </div>

                    <div className="flex flex-col sm:flex-row items-center gap-4 pt-6">
                        <button
                            type="submit"
                            disabled={loading}
                            className="flex-[2] w-full bg-red-600 hover:bg-red-700 text-white font-black py-4 px-8 rounded-2xl flex items-center justify-center gap-3 transition-all shadow-xl shadow-red-900/20 active:scale-[0.98] disabled:opacity-70 disabled:cursor-not-allowed group uppercase tracking-widest text-[13px]"
                        >
                            <span>Submit Emergency Request</span>
                            <FiFileText className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
                        </button>
                        <button
                            type="button"
                            onClick={onBack}
                            className="flex-1 w-full px-8 py-4 bg-white border-2 border-gray-100 text-gray-500 font-bold rounded-2xl hover:bg-gray-50 hover:text-gray-700 transition-all active:scale-[0.98]"
                        >
                            Discard
                        </button>
                    </div>
                </form>
            </div>
        </>
    );
};

export default EmergencyLeave;

